import React, { Component } from 'react';
import {
    Carousel,
    CarouselCaption,
    CarouselControl,
    CarouselItem,
    CarouselIndicators,
    Col,
    Row
} from 'reactstrap';
import './ShojiCarousel.css';

export class ShojiCarousel extends Component {
    constructor(props) {
        super(props);
        this.state = { activeIndex: 0 };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.goToIndex = this.goToIndex.bind(this);
        this.onExiting = this.onExiting.bind(this);
        this.onExited = this.onExited.bind(this);
    }

    renderCarouselItemCol(item) {
        try {
            switch(item.type) {
                case "IMAGE":
                    return (
                        <img src={item.src} className={'p-3 m-auto'} style={{ display: 'table-cell', verticalAlign: 'middle', maxWidth: '100%'}}/>
                    );
                case "TEXT":
                    return (
                        <div className={'p-3 m-auto'} style={{ display: 'table-cell', verticalAlign: 'middle' }}>
                            <h5>{item.title}</h5>
                            <p>{item.subtitle}</p>
                        </div>
                    );
            }
        } catch(error) {
            console.log(error);
        }
    }
    
    onExiting() {
        this.animating = true;
    }

    onExited() {
        this.animating = false;
    }

    next() {
        if (this.animating){
            return;
        }
        const nextIndex = this.state.activeIndex === this.props.items.length - 1 ? 0 : this.state.activeIndex + 1;
        this.setState({ activeIndex: nextIndex });
    }

    previous() {
        if (this.animating){
            return;
        }
        const nextIndex = this.state.activeIndex === 0 ? this.props.items.length - 1 : this.state.activeIndex - 1;
        this.setState({ activeIndex: nextIndex });
    }

    goToIndex(newIndex) {
        if (this.animating){
            return;
        }
        this.setState({ activeIndex: newIndex });
    }

    render() {
        const { activeIndex } = this.state;
        const slides = this.props.items.map((item) => {
            return (
                <CarouselItem
                    onExiting={this.onExiting}
                    onExited={this.onExited}
                    key={item.key}>
                    <Row>
                        <Col xl={5} lg={5} md={5} sm={12} xs={12} className={'ml-auto mr-0'} style={{ display: 'table', minHeight: '480px', maxHeight: '480px'}}>
                            {this.renderCarouselItemCol(item.left)}
                        </Col>
                        <Col xl={5} lg={5} md={5} sm={12} xs={12} className={'ml-0 mr-auto'} style={{ display: 'table', minHeight: '480px', maxHeight: '480px'}}>
                            {this.renderCarouselItemCol(item.right)}
                        </Col>
                    </Row>
                    <CarouselCaption captionText={item.caption} captionHeader={item.caption} />
                </CarouselItem>
            );
        });
        return (
            <Carousel
                activeIndex={activeIndex}
                next={this.next}
                previous={this.previous}
                className={'shoji-carousel'}
            >
                <CarouselIndicators items={this.props.items} activeIndex={activeIndex} onClickHandler={this.goToIndex} />
                {slides}
                <CarouselControl direction="prev" directionText="Previous" onClickHandler={this.previous} />
                <CarouselControl direction="next" directionText="Next" onClickHandler={this.next} />
            </Carousel>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/carousel/ShojiCarousel.js